<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  {{ title }}
</aionz-header-bottom-sheet>

<aionz-dialog-content class="dialog-content">
  @if (subtitle) {
    <p class="dialog-subtitle">{{ subtitle }}</p>
  }
  @for (field of fields(); track field.key) {
    <section class="upload-section">
      <p class="section-label">{{ field.order }}. {{ field.label }}</p>

      <div
        class="dropzone"
        [class.drag-over]="field.isDragOver"
        [class.file-selected]="!!field.file"
        [class.dropzone-error]="field.errors.length > 0"
        [class.dropzone-interactive]="!field.file"
        [attr.role]="field.file ? null : 'button'"
        [attr.tabindex]="field.file ? null : '0'"
        [attr.aria-label]="field.file ? null : field.placeholder"
        (click)="field.file ? null : openFilePicker(field.key, $event)"
        (keydown)="field.file ? null : onDropzoneKeydown($event, field.key)"
        (dragover)="onDragOver($event, field.key)"
        (dragleave)="onDragLeave($event, field.key)"
        (drop)="onDrop($event, field.key)">
        @if (field.file) {
          <div class="uploaded-file-content">
            <mat-icon
              [svgIcon]="field.svgIcon"
              class="file-icon-sm"
              aria-hidden="true" />

            <span class="uploaded-file-details">
              <span class="uploaded-file-name">{{ field.file.name }}</span>
              <span class="uploaded-file-size">{{ field.formattedSize }}</span>
            </span>
          </div>
        } @else {
          <mat-icon
            [svgIcon]="field.svgIcon"
            class="file-icon-lg"
            aria-hidden="true" />
          <span class="dropzone-title">{{ field.placeholder }}</span>
          <span class="dropzone-meta">{{ field.maxSizeLabel }}</span>
        }

        @if (field.file) {
          <div class="file-actions">
            @if (field.errors.length > 0) {
              <mat-icon
                class="error-icon"
                aria-hidden="true">
                warning
              </mat-icon>
            }

            <button
              type="button"
              mat-icon-button
              class="remove-file-button"
              aria-label="Remover arquivo selecionado"
              [disabled]="isSubmitting()"
              (click)="clearFile($event, field.key)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        }

        @if (field.errors.length > 0) {
          <div class="file-error-panel">
            <p class="file-error-title">Problemas encontrados:</p>
            <ul class="file-error-list">
              @for (error of field.errors; track error) {
                <li>{{ error }}</li>
              }
            </ul>
          </div>
        }
      </div>
    </section>
  }

  @if (showUploadedFilesNotice()) {
    <div
      class="uploaded-files-notice"
      role="status"
      aria-live="polite">
      <mat-icon
        class="notice-icon"
        aria-hidden="true">
        info_outline
      </mat-icon>
      <p class="notice-text">
        Revise os arquivos anexados. Você poderá substituí-los se necessário clicando no ícone de
        lixeira ao lado do arquivo desejado.
      </p>
    </div>
  }

  <input
    #spreadsheetInput
    type="file"
    accept=".xlsx,.xls,.csv"
    hidden
    (change)="onFileChange($event, 'spreadsheet')" />

  <input
    #quoteInput
    type="file"
    accept=".pdf,application/pdf"
    hidden
    (change)="onFileChange($event, 'quote')" />
</aionz-dialog-content>

<aionz-dialog-actions
  align="end"
  class="dialog-footer">
  <button
    type="button"
    mat-stroked-button
    class="back-button"
    [disabled]="isSubmitting()"
    (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
    Voltar
  </button>

  <button
    type="button"
    mat-flat-button
    class="submit-button"
    [disabled]="!canSubmit() || isSubmitting()"
    (click)="submit()">
    @if (isSubmitting()) {
      <div class="button-loading">
        <mat-spinner
          diameter="18"
          class="button-spinner"
          strokeWidth="3">
        </mat-spinner>
        <span>Aguarde...</span>
      </div>
    } @else {
      Enviar Arquivos
    }
  </button>
</aionz-dialog-actions>
